import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { BsChatRight } from "react-icons/bs";
import { MdAutoGraph } from "react-icons/md";
import { RiToolsFill } from "react-icons/ri";
import { TbVersionsFilled } from "react-icons/tb";
import { RemoveScroll } from "react-remove-scroll";
import styled from "styled-components";

import { GoDot } from "react-icons/go";
import { useAppContext } from "../context/ThemeContext";
import Calendly from "../reusable-components/Calendly";
import { ChatForm } from "../reusable-components/ChatForm";
import Layout from "../reusable-components/Layout";
import { PaymentCard } from "../reusable-components/payment/PaymentCard";
import Spiral from "../reusable-components/Spiral";
import TitleListComponent from "../reusable-components/TitleListComponent";
import { getAllData } from "../utilities/firebase-connection";
const promise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function Nexus() {
  const { siteTheme, state } = useAppContext();
  const [nexus, setNexus] = useState({});
  const [loading, setLoading] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const { REACT_APP_SCHEDULE_PAYMENT } = process.env;

  let isDay = state.isDay;
  if (JSON.parse(sessionStorage.getItem("isDay"))) {
    isDay = JSON.parse(sessionStorage.getItem("isDay"));
  }

  useEffect(() => {
    let loadId;
    (async () => {
      setLoading(true);
      const consl = await getAllData("consultations");
      setNexus(consl[0]);

      loadId = setTimeout(() => {
        setLoading(false);
      }, 2000);
    })();

    return () => clearTimeout(loadId);
  }, []);

  const listInformationArray = [
    {
      Icon: <MdAutoGraph size={14} />,
      data: nexus?.clearValueProposition,
      title:
        "We Help Businesses Grow by Building High-Impact Web & Mobile Apps That Drive Results",
    },
    {
      Icon: <RiToolsFill size={14} />,
      data: nexus?.description,
      title: "How it Works",
    },
    {
      Icon: <TbVersionsFilled size={14} />,
      data: nexus?.industrySpecificVersions,
      title: "Industry Specific Versions",
    },
  ];
  const services = nexus?.services?.map((service) => ({
    data: service?.description,
    title: service?.title,
  }));

  return (
    <>
      <Helmet>
        <title>Wiingr | Home</title>
      </Helmet>
      <Layout>
        <div
          className={`${siteTheme.textColor} ease-in duration-300 relative flex flex-col w-full h-[100%] px-4 mx-auto max-w-max-content-width pb-20 overflow-y-scroll overflow-x-hidden no-scrollbar`}
        >
          <div className="relative flex items-center justify-end w-full h-[400px] ">
            <div className="absolute bottom-0 left-0 right-0 z-20">
              <span className="absolute top-[23%] left-20 text-2xl tracking-[0.5em] font-thin drop-shadow-[0_0_5px_#ffea00]">
                ...think
              </span>
              <p className="text-[276px] text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-pink-500 h-[180px] leading-none opacity-[0.3] font-thin drop-shadow-[0_0_10px_#ffea00]">
                innovation
              </p>
            </div>
            <Spiral siteTheme={siteTheme} />
          </div>
          <div className="relative font-thin mt-52 font-saira">
            <h1
              className={`mb-12 hidden sm:inline-block sm:text-4xl text-center w-full`}
            >
              Book a Free Consultation
            </h1>
            <h1 className="w-full mb-2 text-2xl text-center sm:hidden sm:text-4xl">
              Book a Free
              <span
                className={`${
                  state?.isDay ? "border-neutral-300" : "border-neutral-800"
                } block -mt-2 text-5xl border-b-[0.5px] pb-1`}
              >
                {" "}
                Consultation
              </span>
            </h1>
            <div className="gap-5 columns-1 md:columns-2 xl:columns-3">
              {listInformationArray?.map((list, idx) => (
                <TitleListComponent
                  key={idx}
                  data={list}
                  loading={loading}
                  siteTheme={siteTheme}
                />
              ))}
            </div>
            <div className="flex flex-col items-center justify-center w-full mx-auto mt-20 max-w-max-content-width">
              <div className="flex items-center justify-center w-full mx-auto">
                <div className="w-[50%] h-[0.5px] bg-gradient-to-r from-transparent to-linesLight" />
                <GoDot
                  size={20}
                  color="rgba(117, 117, 117, 0.5)"
                  className="mx-2"
                />
                <p
                  className={`${siteTheme.textColor} text-[10px] tracking-[0.1em] uppercase font-thin font-saira`}
                >
                  Services
                </p>
                <GoDot
                  size={20}
                  color="rgba(117, 117, 117, 0.5)"
                  className="mx-2"
                />
                <div className="w-[50%] h-[0.5px] bg-gradient-to-r to-transparent from-linesLight" />
              </div>
            </div>
            <div className="gap-5 mt-10 columns-1 md:columns-2 xl:columns-3">
              {services?.map((list, idx) => (
                <TitleListComponent
                  key={idx}
                  data={list}
                  loading={loading}
                  siteTheme={siteTheme}
                />
              ))}
            </div>
          </div>
        </div>
        {showChat && (
          <RemoveScroll>
            <ChatForm
              siteTheme={siteTheme}
              isDay={isDay}
              showChat={showChat}
              setShowChat={setShowChat}
            />
          </RemoveScroll>
        )}
        {!showChat && (
          <div
            className={`${
              isDay ? "bg-brandBlack" : "bg-brandWhite"
            } ease-in duration-300 hidden sm:flex fixed z-30 bottom-3 right-4 items-center justify-center rounded-full cursor-pointer w-[60px] h-[60px] backdrop-blur-sm`}
          >
            <BsChatRight
              size={25}
              color={isDay ? "#fff" : "#171e25"}
              onClick={() => {
                setShowChat(true);
                setShowPayment(false);
              }}
            />
          </div>
        )}
        {showPayment && (
          <div className="fixed mx-4 duration-300 ease-in paycard bottom-20 h-fit font-saira xs:w-[50vw] xs:right-0 z-20 lg:w-[35vw] xl:w-[25vw]">
            <div
              className={`tracking-wide ${
                isDay ? "bg-neutral-800 text-white" : "bg-neutral-50 text-black"
              } text-xs w-full mb-1 p-2 rounded-lg`}
            >
              <p>💬 We’d love to connect with you!</p>
              <br />
              <p>{`To confirm your meeting, we require a CAD $${process.env.REACT_APP_SCHEDULE_PAYMENT} payment, which helps us ensure dedicated time and personalized attention to your needs.`}</p>
              <br />
              <p>
                Once your payment is completed, you’ll be able to schedule a
                time that works best for you.
                <br />
                Thank you for choosing us — we look forward to speaking with
                you!
              </p>
            </div>
            <Wrapper>
              <Elements stripe={promise}>
                <PaymentCard
                  isDay={isDay}
                  setIsOpen={setIsOpen}
                  due={REACT_APP_SCHEDULE_PAYMENT}
                  isResumePayment={false}
                  extraFunction={() => {}}
                />
              </Elements>
            </Wrapper>
          </div>
        )}
        <Calendly
          isDay={isDay}
          showChat={showChat}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          showPayment={showPayment}
          setShowChat={setShowChat}
          setShowPayment={setShowPayment}
        />
      </Layout>
    </>
  );
}

const Wrapper = styled.section`
  form {
    width: 100%;
    align-self: center;
    box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
      0px 2px 5px 0px rgba(50, 50, 93, 0.1),
      0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
    border-radius: 7px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 30px;
  }

  input {
    border-radius: 6px;
    margin-bottom: 6px;
    padding: 12px;
    border: 1px solid rgba(50, 50, 93, 0.1);
    max-height: 44px;
    font-size: 16px;
    width: 100%;
    background: white;
    box-sizing: border-box;
  }

  .result-message {
    line-height: 22px;
    font-size: 16px;
  }

  .result-message a {
    color: rgb(89, 111, 214);
    font-weight: 600;
    text-decoration: none;
  }

  .hidden {
    display: none;
  }

  #card-error {
    color: rgb(105, 115, 134);
    font-size: 16px;
    line-height: 20px;
    margin-top: 12px;
    text-align: center;
  }

  #card-element {
    max-height: 44px;
    width: 100%;
    box-sizing: border-box;
  }

  #payment-request-button {
    margin-bottom: 32px;
  }

  button:hover {
    filter: contrast(115%);
  }

  button:disabled {
    opacity: 0.5;
    cursor: default;
  }

  /* spinner/processing state, errors */
  .spinner,
  .spinner:before,
  .spinner:after {
    border-radius: 50%;
  }

  .spinner {
    color: #fff;
    font-size: 22px;
    text-indent: -99999px;
    margin: 0px auto;
    position: relative;
    width: 20px;
    height: 20px;
    box-shadow: inset 0 0 0 2px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }

  .spinner:before,
  .spinner:after {
    position: absolute;
    content: "";
  }

  .spinner:before {
    width: 10.4px;
    height: 20.4px;
    background: undefined;
    border-radius: 20.4px 0 0 20.4px;
    top: -0.2px;
    left: -0.2px;
    -webkit-transform-origin: 10.4px 10.2px;
    transform-origin: 10.4px 10.2px;
    -webkit-animation: loading 2s infinite ease 1.5s;
    animation: loading 2s infinite ease 1.5s;
  }

  .spinner:after {
    width: 10.4px;
    height: 10.2px;
    background: undefined;
    border-radius: 0 10.2px 10.2px 0;
    top: -0.1px;
    left: 10.2px;
    -webkit-transform-origin: 0px 10.2px;
    transform-origin: 0px 10.2px;
    -webkit-animation: loading 2s infinite ease;
    animation: loading 2s infinite ease;
  }

  @keyframes loading {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;

export default Nexus;
